export const formatTokenCount = (n: number): string => new Intl.NumberFormat('en-US').format(n);
